

export const handleToggleRowHeader = ({ value, onChange, id }) => {
    const { data, colWidthConfig } = value;
  
    let newData = data.map((row, rowIdx) => {
      if(row.isColHeader){ //then remove
        const newRow = {
          ...row
        }
        delete newRow.isColHeader
        return newRow
      }else{ //else add
        return {
          ...row,
          ...(rowIdx === 0 ? { isColHeader: true } : {})
        };
      }    
    });
  
    onChange &&
      onChange(id, { data: newData, colWidthConfig });
  };
  
